export const required = value => (!value ? 'validation.required' : undefined);

const EMAIL_VALIDATION_REGEX =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})$/;

export const validateEmail = email => {
  const pattern = RegExp(EMAIL_VALIDATION_REGEX);
  return pattern.test(email) ? undefined : 'validation.email';
};
